import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// The "New folder" affordance in the Files app toolbar: a trigger button that
// swaps for an inline name field, POSTs to UserFoldersController#create
// (JSON), then reloads so the new folder renders server-side alongside its
// siblings (breadcrumb, quota, etc. all come from the same page load).
export default class extends Controller {
    static targets = ["trigger", "form", "input"]
    static values = { url: String, parent: String }

    start(event) {
        event?.preventDefault()
        this.triggerTarget.hidden = true
        this.formTarget.hidden = false
        this.inputTarget.value = ""
        this.inputTarget.focus()
    }

    cancel(event) {
        event?.preventDefault()
        this._close()
    }

    create(event) {
        event.preventDefault()
        const name = this.inputTarget.value.trim()
        if (!name) return

        const body = { name }
        if (this.parentValue) body.parent_id = this.parentValue

        fetch(this.urlValue, {
            method: "POST",
            headers: { Accept: "application/json", "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin",
            body: JSON.stringify(body)
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.ok) {
                    window.location.reload()
                } else {
                    window.alert(data.error || "Could not create that folder.")
                    this._close()
                }
            })
            .catch(() => {
                window.alert("Could not create that folder - check your connection.")
                this._close()
            })
    }

    _close() {
        this.formTarget.hidden = true
        this.triggerTarget.hidden = false
    }
}
